import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge class names, resolving conflicting Tailwind utilities so the last one wins.
 *
 * `clsx` flattens the arguments and drops falsy ones; `twMerge` then resolves
 * conflicts within the same Tailwind group, so `cn('p-2', 'p-4')` yields `p-4`
 * rather than both. That is the behaviour every component here relies on when it
 * accepts a `className` prop and expects the caller's value to override its own.
 */
export function cn(...inputs: ClassValue[]): string {
	return twMerge(clsx(inputs));
}
